import React from 'react';
import { DialogContentText } from '@mui/material';
import { useGlobalization } from '@Translations/useGlobalization';
import { DeleteConfirmationDialog } from './DeleteConfirmationDialog';

interface DeleteFailureDefinitionDialogProps {
	open: boolean;
	failureDefinitionName: string;
	onClose: () => void;
	onConfirm: () => void;
}

export const DeleteFailureDefinitionDialog: React.FC<DeleteFailureDefinitionDialogProps> = ({
	open,
	failureDefinitionName,
	onClose,
	onConfirm,
}) => {
	const { t } = useGlobalization();

	return (
		<DeleteConfirmationDialog
			open={open}
			title={t('Delete Failure Definition')}
			onClose={onClose}
			onConfirm={onConfirm}>
			<DialogContentText>
				{t('Are you sure you want to delete the failure definition "{{name}}"? This action cannot be undone.', {
					name: failureDefinitionName,
				})}
			</DialogContentText>
		</DeleteConfirmationDialog>
	);
};
